import createSchemaCustomization from './createSchemaCustomization';

export default createSchemaCustomization;
